<template>
  <div v-if="tagList.length > 0" class="hashtag mt40">
    <h2 class="title c5a ab">ハッシュタグ一覧</h2>
    <div class="hashtag_list">
      <router-link class="hashtag_link ar" v-for="(val, index) in tagList" :to="{ name: 'ColumnList', query: { resultType: 'hashtag', search: val.tagName, tagId: val.tagId } }" :key="index">{{ val.tagName }}</router-link>
    </div>
  </div>
</template>

<script>
import TagList from '@/components/api/fanClub/article';

export default {
  data() {
    return {
      tagList: [],
    }
  },
  async created() {
    await TagList.getTagList().then((val) => {
      console.log('ハッシュタグ');
      console.log(val);
      this.tagList.push(...val)
    });
  }
}
</script>

<style lang="css" scoped>
.hashtag {}
.title {
  text-align: center;
}
.hashtag_list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
}
.hashtag_link {
  font-size: 14px;
  line-height: 1;
  margin-right: 8px;
  margin-bottom: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/HashtagList.vue